import { useCallback } from 'react';
import { useSearchParams } from 'next/navigation';
import { Product, ProductCardProduct } from 'shared/types/product/Product';
import { RouteHelpers } from 'helpers/routerHelpers';
import { matchVariantByColor } from 'helpers/utils/product/variants';
import ProductRecommendationGrid from './ProductRecommendationGrid';

interface Props {
  products: ProductCardProduct[];
  product: Product;
}

const ProductsYouMayAlsoLikeSection = ({ products, product }: Props) => {
  const search = useSearchParams();
  const selectedColor = RouteHelpers.slugify(search.get('color') || '');

  const colorMatcher = useCallback(
    (youMayAlsoLikeProduct: ProductCardProduct) => {
      // Get current variant selected based on color search param or default master variant
      const selectedVariant = selectedColor
        ? product.variants.find(
            (variant) => RouteHelpers.slugify(variant?.attributes?.actualColor || '') === selectedColor,
          )
        : product.masterVariant;

      return matchVariantByColor(selectedVariant, youMayAlsoLikeProduct);
    },
    [product, selectedColor],
  );

  if (!products || products.length === 0) return null;

  return (
    <ProductRecommendationGrid
      title="You May Also Like"
      products={products}
      location="You May Also Like"
      maxItems={4}
      sectionId="related-products"
    />
  );
};

export default ProductsYouMayAlsoLikeSection;
